export default __webpack_public_path__ + "static/media/Parodontology.487803f7.png";